import { chainImgs } from '@/lib/imgs';
import { ChainInfo, TokenInfo } from '@/lib/dex-api';

export const evmChainIds = [1, 56, 8453, 42161, 137, 196];

export const chainList: ChainInfo[] = [
  {
    chainId: 42161,
    chainIndex: 42161,
    chainName: 'Arbitrum',
    chainNameForWallet: 'Arbitrum One',
    dexTokenApproveAddress: '0x70cBb871E8f30Fc8Ce23609E9E0Ea87B6b222F58',
    img: chainImgs.arbitrum,
    type: 'evm',
    rpcUrl: 'https://rpc.ankr.com/arbitrum/c6b738a490992d7e86036906e1bcc5eb313cea37a518118a3d7486242d7c1eb0',
    mainTokenAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee', //ARB
    mainTokenSymbol: 'ARB_ETH',
    mainTokenDecimals: '18',
    tradeDetailUrl: 'https://web3.okx.com/zh-hans/explorer/arbitrum-one/tx/',
    hashUrl: 'https://www.oklink.com/zh-hans/arbitrum',
    minRetainedBalance: 0.0005, // arb eth
    tokenList: [
      {
        decimals: '18',
        tokenContractAddress: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        tokenLogoUrl: 'https://static.okx.com/cdn/wallet/logo/arb_9000.png',
        tokenName: 'Arbitrum One',
        tokenSymbol: 'ARB_ETH',
      },
      {
        decimals: '6',
        tokenContractAddress: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
        tokenLogoUrl:
          'https://static.okx.com/cdn/web3/currency/token/large/137-0x1e4a5963abfd975d8c9021ce480b42188849d41d-107/type=default_90_0?v=1761546595172g',
        tokenName: 'Tether USD',
        tokenSymbol: 'USDT',
      },
      {
        decimals: '18',
        tokenContractAddress: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
        tokenLogoUrl:
          'https://static.okx.com/cdn/web3/currency/token/large/637-0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b-107/type=default_90_0?v=1756203256814',
        tokenName: 'USD Coin',
        tokenSymbol: 'USDC',
      },
    ],
  },
  {
    chainId: 8453,
    chainIndex: 8453,
    chainName: 'Base',
    chainNameForWallet: 'Base',
    dexTokenApproveAddress: '0x57df6092665eb6058DE53939612413ff4B09114E',
    img: chainImgs.base,
    type: 'evm',
    rpcUrl: 'https://rpc.ankr.com/base/c6b738a490992d7e86036906e1bcc5eb313cea37a518118a3d7486242d7c1eb0',
    mainTokenAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee', //BASE
    mainTokenSymbol: 'BASE_ETH',
    mainTokenDecimals: '18',
    tradeDetailUrl: 'https://web3.okx.com/zh-hans/explorer/base/tx/',
    hashUrl: 'https://www.oklink.com/zh-hans/base',
    minRetainedBalance: 0.0005, // base eth
    tokenList: [
      {
        tokenSymbol: 'BASE_ETH',
        tokenName: 'Base',
        tokenContractAddress: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        tokenLogoUrl: 'https://static.okx.com/cdn/wallet/logo/base_20800_new.png',
        decimals: '18',
      },
      {
        tokenSymbol: 'USDT',
        tokenName: 'Tether USD',
        tokenContractAddress: '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2',
        tokenLogoUrl:
          'https://static.okx.com/cdn/web3/currency/token/large/137-0x1e4a5963abfd975d8c9021ce480b42188849d41d-107/type=default_90_0?v=1761546595172',
        decimals: '6',
      },
      {
        tokenSymbol: 'USDC',
        tokenName: 'USD Coin',
        tokenContractAddress: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        tokenLogoUrl:
          'https://static.okx.com/cdn/web3/currency/token/large/637-0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b-107/type=default_90_0?v=1756203256814',
        decimals: '6',
      },
    ],
  },
  {
    chainId: 56,
    chainIndex: 56,
    chainName: 'BSC',
    chainNameForWallet: 'BNB Smart Chain',
    dexTokenApproveAddress: '0x2c34A2Fb1d0b4f55de51E1d0bDEfaDDce6b7cDD6',
    img: chainImgs.bsc,
    type: 'evm',
    rpcUrl: 'https://rpc.ankr.com/bsc/c6b738a490992d7e86036906e1bcc5eb313cea37a518118a3d7486242d7c1eb0',
    mainTokenAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee', //BNB
    mainTokenSymbol: 'BNB',
    mainTokenDecimals: '18',
    tradeDetailUrl: 'https://web3.okx.com/zh-hans/explorer/bsc/tx/',
    hashUrl: 'https://www.oklink.com/zh-hans/bsc',
    minRetainedBalance: 0.001, // bnb
    tokenList: [
      {
        tokenSymbol: 'BNB',
        tokenName: 'BNB Chain',
        tokenContractAddress: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        tokenLogoUrl: 'https://static.okx.com/cdn/wallet/logo/bnb_5000_new.png',
        decimals: '18',
      },
      {
        tokenSymbol: 'USDT',
        tokenName: 'Tether USD',
        tokenContractAddress: '0x55d398326f99059ff775485246999027b3197955',
        tokenLogoUrl:
          'https://static.okx.com/cdn/web3/currency/token/large/137-0x1e4a5963abfd975d8c9021ce480b42188849d41d-107/type=default_90_0?v=1761546595172',
        decimals: '6',
      },
      {
        tokenSymbol: 'USDC',
        tokenName: 'USD Coin',
        tokenContractAddress: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
        tokenLogoUrl:
          'https://static.okx.com/cdn/web3/currency/token/large/637-0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b-107/type=default_90_0?v=1756203256814',
        decimals: '18',
      },
    ],
  },
  {
    chainId: 501,
    chainIndex: 501,
    chainName: 'Solana',
    chainNameForWallet: 'Solana',
    dexTokenApproveAddress: '',
    img: chainImgs.solana,
    type: 'solana',
    rpcUrl: 'https://rpc.ankr.com/solana/c6b738a490992d7e86036906e1bcc5eb313cea37a518118a3d7486242d7c1eb0',
    mainTokenAddress: '11111111111111111111111111111111', //SOL
    mainTokenSymbol: 'SOL',
    mainTokenDecimals: '9',
    tradeDetailUrl: 'https://solscan.io/tx/',
    hashUrl: 'https://www.oklink.com/zh-hans/solana',
    minRetainedBalance: 0.01, // sol
    tokenList: [
      {
        tokenSymbol: 'SOL',
        tokenName: 'Solana',
        tokenContractAddress: '11111111111111111111111111111111',
        tokenLogoUrl: 'https://static.okx.com/cdn/wallet/logo/SOL-20220525.png',
        decimals: '9',
      },
      {
        tokenSymbol: 'USDT',
        tokenName: 'Tether USD',
        tokenContractAddress: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
        tokenLogoUrl:
          'https://static.okx.com/cdn/web3/currency/token/large/137-0x1e4a5963abfd975d8c9021ce480b42188849d41d-107/type=default_90_0?v=1761546595172',
        decimals: '6',
      },
      {
        tokenSymbol: 'USDC',
        tokenName: 'USD Coin',
        tokenContractAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
        tokenLogoUrl:
          'https://static.okx.com/cdn/web3/currency/token/large/637-0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b-107/type=default_90_0?v=1756203256814',
        decimals: '6',
      },
    ],
  },
  {
    chainId: 1,
    chainIndex: 1,
    chainName: 'Ethereum',
    chainNameForWallet: 'Ethereum',
    dexTokenApproveAddress: '0x40aA958dd87FC8305b97f2BA922CDdCa374bcD7f',
    img: chainImgs.ethereum,
    type: 'evm',
    rpcUrl: 'https://rpc.ankr.com/eth/c6b738a490992d7e86036906e1bcc5eb313cea37a518118a3d7486242d7c1eb0',
    mainTokenAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee', //ETH
    mainTokenSymbol: 'ETH',
    mainTokenDecimals: '18',
    tradeDetailUrl: 'https://web3.okx.com/zh-hans/explorer/ethereum/tx/',
    hashUrl: 'https://www.oklink.com/zh-hans/ethereum',
    minRetainedBalance: 0.005, // eth
    tokenList: [
      {
        tokenSymbol: 'ETH',
        tokenName: 'Ethereum',
        tokenContractAddress: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        tokenLogoUrl: 'https://static.okx.com/cdn/wallet/logo/ETH-20220328.png',
        decimals: '18',
      },
      {
        tokenSymbol: 'USDT',
        tokenName: 'Tether USD',
        tokenContractAddress: '0xdac17f958d2ee523a2206206994597c13d831ec7',
        tokenLogoUrl:
          'https://static.okx.com/cdn/web3/currency/token/large/137-0x1e4a5963abfd975d8c9021ce480b42188849d41d-107/type=default_90_0?v=1761546595172',
        decimals: '6',
      },
      {
        tokenSymbol: 'USDC',
        tokenName: 'USD Coin',
        tokenContractAddress: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
        tokenLogoUrl:
          'https://static.okx.com/cdn/web3/currency/token/large/637-0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b-107/type=default_90_0?v=1756203256814',
        decimals: '6',
      },
    ],
  },
  {
    chainId: 196,
    chainIndex: 196,
    chainName: 'X Layer',
    chainNameForWallet: 'X Layer',
    dexTokenApproveAddress: '0x8b773D83bc66Be128c60e07E17C8901f7a64F000',
    img: chainImgs.xLayer,
    type: 'evm',
    rpcUrl: 'https://rpc.ankr.com/xlayer/c6b738a490992d7e86036906e1bcc5eb313cea37a518118a3d7486242d7c1eb0',
    mainTokenAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee', // XLAYER
    mainTokenSymbol: 'OKB',
    mainTokenDecimals: '18',
    tradeDetailUrl: 'https://web3.okx.com/zh-hans/explorer/x-layer/tx/',
    hashUrl: 'https://www.oklink.com/zh-hans/x-layer',
    minRetainedBalance: 0.01, // xlayer okb
    tokenList: [],
  },
  {
    chainId: 137,
    chainIndex: 137,
    chainName: 'Polygon',
    chainNameForWallet: 'Polygon',
    dexTokenApproveAddress: '0x3B86917369B83a6892f553609F3c2F439C184e31',
    img: chainImgs.polygon,
    type: 'evm',
    rpcUrl: 'https://rpc.ankr.com/polygon/c6b738a490992d7e86036906e1bcc5eb313cea37a518118a3d7486242d7c1eb0',
    mainTokenAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee', // POL
    mainTokenSymbol: 'POL',
    mainTokenDecimals: '18',
    tradeDetailUrl: 'https://web3.okx.com/zh-hans/explorer/polygon/tx/',
    hashUrl: 'https://www.oklink.com/zh-hans/polygon',
    minRetainedBalance: 0.5, // pol
    tokenList: [
      {
        tokenSymbol: 'POL',
        tokenName: 'Polygon',
        tokenContractAddress: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        tokenLogoUrl: 'https://static.okx.com/cdn/wallet/logo/pol_6000_new.png',
        decimals: '18',
      },
      {
        tokenSymbol: 'USDT',
        tokenName: 'Tether USD',
        tokenContractAddress: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
        tokenLogoUrl:
          'https://static.okx.com/cdn/web3/currency/token/large/137-0x1e4a5963abfd975d8c9021ce480b42188849d41d-107/type=default_90_0?v=1761546595172',
        decimals: '6',
      },
      {
        tokenSymbol: 'USDC',
        tokenName: 'USD Coin',
        tokenContractAddress: '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359',
        tokenLogoUrl:
          'https://static.okx.com/cdn/web3/currency/token/large/637-0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b-107/type=default_90_0?v=1756203256814',
        decimals: '6',
      },
    ],
  },
];

export const allChains = [
  {
    chainId: 0,
    chainIndex: 0,
    chainName: '全部网络',
    dexTokenApproveAddress: '',
    img: chainImgs.all,
  },
  ...chainList,
];

export const perpsUSDC: TokenInfo = {
  chainId: -1,
  tokenSymbol: 'USDC',
  tokenName: 'USDC',
  tokenContractAddress: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
  tokenLogoUrl: chainImgs.usdc,
  decimals: '6',
};

export const arbitrumUSDC: TokenInfo = {
  chainId: 42161,
  tokenSymbol: 'USDC',
  tokenName: 'USDC',
  tokenContractAddress: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
  tokenLogoUrl: chainImgs.usdc,
  decimals: '6',
};

export const hyperliquidChain: ChainInfo = {
  chainId: -1,
  chainIndex: -1,
  chainName: 'Perps',
  chainNameForWallet: 'Perps',
  dexTokenApproveAddress: '',
  img: chainImgs.hyperliquid,
  type: 'evm',
  rpcUrl: '',
  mainTokenAddress: '',
  mainTokenSymbol: 'USDC',
  mainTokenDecimals: '',
  tokenList: [perpsUSDC],
  tradeDetailUrl: '',
  hashUrl: '',
  minRetainedBalance: 0,
};

// 划转不支持xlayer
export const convertChains = [...chainList.filter(item => item.chainId !== 196), hyperliquidChain];

export const predictUSDCe: TokenInfo = {
  chainId: -2,
  tokenSymbol: 'USDC.e',
  tokenName: 'USDC.e',
  tokenContractAddress: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
  tokenLogoUrl: chainImgs.usdc,
  decimals: '6',
};

export const predictChain = {
  chainId: -2,
  chainIndex: -2,
  chainName: 'Predict',
  chainNameForWallet: 'Predict',
  dexTokenApproveAddress: '',
  img: chainImgs.polymarket,
  type: 'evm',
  rpcUrl: '',
  mainTokenAddress: '',
  mainTokenSymbol: 'USDC.e',
  mainTokenDecimals: '',
  tokenList: [],
} as any as ChainInfo;

export const defaultChain = chainList[0];

export const defaultTokenFrom = {
  decimals: '9',
  tokenContractAddress: '11111111111111111111111111111111',
  tokenLogoUrl: 'https://static.okx.com/cdn/wallet/logo/SOL-20220525.png',
  tokenName: 'Solana',
  tokenSymbol: 'SOL',
};

export const defaultTokenTo = {
  decimals: '6',
  tokenContractAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
  tokenLogoUrl:
    'https://static.okx.com/cdn/web3/currency/token/small/637-0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b-1?v=1742202380789',
  tokenName: 'USD Coin',
  tokenSymbol: 'USDC',
};

// 按照指定的chainId顺序排序
export const sortByChainOrder = (chainOrder: number[]) => {
  const orderMap = new Map(chainOrder.map((id, index) => [id, index]));

  return chainList.slice().sort((a, b) => {
    return (orderMap.get(a.chainId) ?? Infinity) - (orderMap.get(b.chainId) ?? Infinity);
  });
};
